import { CommentsSection } from "./CommentsSection";
import { SocialFollowBox } from "./SocialFollowBox";
import type { ArticleLang } from "@/lib/article-types";

/**
 * Desktop sidebar shown next to the article on movie/series pages.
 *
 * It keeps the social-follow box sticky at the top, and places the comments
 * section directly below it so the discussion is visible while reading the
 * article. The whole column uses `position: sticky` so it naturally unsticks
 * when the article ends, while a gradient accent line adds a touch of brand
 * personality to the comments card.
 */
export function ArticleSidebar({
  lang,
  threadId,
  title,
}: {
  lang?: ArticleLang;
  threadId: string;
  title: string;
}) {
  return (
    <div className="sticky top-24 space-y-5">
      <SocialFollowBox lang={lang} />

      <div className="relative rounded-2xl border border-border bg-card shadow-card overflow-hidden">
        <div
          className="absolute inset-x-0 top-0 h-1"
          style={{ background: "var(--gradient-primary)" }}
          aria-hidden
        />
        <CommentsSection
          threadId={threadId}
          title={title}
          className="!px-0 !py-0"
          innerClassName="border-0 shadow-none rounded-none p-4 sm:p-5"
        />
      </div>
    </div>
  );
}
